import { ReactElement } from 'react';

import googleAnalytics from '@analytics/google-analytics';
import segment from '@analytics/segment';
import { Analytics } from 'analytics';
import { AnalyticsProvider as ExternalAnalyticsProvider } from 'use-analytics';

export interface AnalyticsProviderProps {
  children: ReactElement;
  applicationName: string;
  segmentAppKey: string;
  googleAnalyticsMeasurementIds: string[];
}

export function AnalyticsProvider({
  children,
  segmentAppKey,
  googleAnalyticsMeasurementIds,
  applicationName,
}: AnalyticsProviderProps) {
  const analytics = Analytics({
    app: applicationName,
    plugins: [
      segment({
        writeKey: segmentAppKey,
      }),
      googleAnalytics({
        measurementIds: googleAnalyticsMeasurementIds,
      }),
    ],
  });

  // @ts-expect-error - Expecting error
  return <ExternalAnalyticsProvider instance={analytics}>{children}</ExternalAnalyticsProvider>;
}
